module.exports = __webpack_public_path__ + "img/logo_big.f2d72910.png";